module.exports = __webpack_public_path__ + "static/media/company_orange.4c86b31e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company_orange.svg
// module id = 543
// module chunks = 0